import segmentWrapper from '@/shared/tracking/segment-wrapper.js'
import auth from '@/shared/auth'
import { initOneTrustFlowWithInjection } from '@ui/one-trust/dist/consent-wiring'
import cookies from '@/shared/cookies'

export default async function () {
  const { segmentWriteKey } = window.siteInfo

  if (segmentWriteKey) {
    // The useOneTrust value is unique to the locale, hence we don't need to check brand.
    if (window.siteInfo.useOneTrust) {
      // initialize segment, but prevent it from loading
      segmentWrapper.init(segmentWriteKey, true)
      // Placeholder for script injection of onetrust here
      initOneTrustFlowWithInjection({ sdkKey: window.siteInfo?.oneTrustSettings?.domainId, segmentWriteKey: segmentWriteKey })
    } else {
      segmentWrapper.init(segmentWriteKey)
    }
    // Identify the user if logged in
    if (auth.isLoggedIn()) {
      segmentWrapper.identify(auth.userData().id)
    }
  } else if (window.newrelic) {
    window.newrelic.noticeError(new Error('segment writekey unavailable'))
  }

  /* We want to set feature flags as new relic custom attribute so that
  we can filter errors by feature flags when rolling out.
  If user in multiple experiments, flags are separated by ':' in the cookie */
  const featureFlags = cookies.get('hb_feature_flags')
  if (featureFlags) {
    // eslint-disable-next-line no-unused-expressions
    window.newrelic?.setCustomAttribute?.('hb_feature_flags', featureFlags)
  }
}
